/**
 * @generated SignedSource<<d058ea2e5a75b730ce7894acf9ee2b8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domId",
  "storageKey": null
},
v8 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPageSectionBase"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsible",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsedHeight",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsRatio",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsOrder",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullHeight",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v15/*: any*/)
  ],
  "type": "PageSectionWithHeadingData",
  "abstractKey": "__isPageSectionWithHeadingData"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v16/*: any*/)
  ],
  "type": "PageSectionSidebarText",
  "abstractKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    (v15/*: any*/),
    (v18/*: any*/)
  ],
  "type": "PageSectionSidebarLinkBlock",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removeRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UsersGroup",
      "kind": "LinkedField",
      "name": "usersGroup",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyGroupMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyRequested",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UsersGroupAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sendJoinGroupRequest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionSidebarUsersGroupRequestLinkBlock",
  "abstractKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hlsUrl",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "format",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaTitle",
  "storageKey": null
},
v26 = [
  (v18/*: any*/),
  (v3/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "transcription",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "audio",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "altText",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x15Url",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x2Url",
  "storageKey": null
},
v34 = [
  (v18/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/)
],
v35 = [
  (v31/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "large",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ratio",
        "storageKey": null
      },
      (v18/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "medium",
    "plural": false,
    "selections": (v34/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "small",
    "plural": false,
    "selections": (v34/*: any*/),
    "storageKey": null
  },
  (v3/*: any*/)
],
v36 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hlsLibUrl",
      "storageKey": null
    },
    (v29/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": (v35/*: any*/),
      "storageKey": null
    }
  ],
  "type": "WithBunnyStreamVideo",
  "abstractKey": "__isWithBunnyStreamVideo"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoplay",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slidesInterval",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Slide",
  "kind": "LinkedField",
  "name": "slides",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableOverlay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentPosition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayOpacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v35/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "LibraryFile",
  "kind": "LinkedField",
  "name": "files",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileExtension",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "ResourceTarget",
  "kind": "LinkedField",
  "name": "resourceTargets",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "analyticsData",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v3/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isAnalyticsDatumInterface"
        },
        (v42/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionAnalyticsDataList",
  "abstractKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zIndexOffset",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opacity",
  "storageKey": null
},
v49 = [
  (v18/*: any*/)
],
v50 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v15/*: any*/),
      (v47/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contrastColor",
        "storageKey": null
      },
      (v29/*: any*/),
      (v30/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetX",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetY",
        "storageKey": null
      },
      (v48/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v49/*: any*/),
            "type": "Image",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v49/*: any*/),
            "type": "StaticImage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MapElementImageStyle",
    "abstractKey": "__isMapElementImageStyle"
  },
  (v3/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementIconStyle",
  "kind": "LinkedField",
  "name": "iconStyle",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementBackgroundStyle",
  "kind": "LinkedField",
  "name": "backgroundStyle",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMin",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMax",
  "storageKey": null
},
v55 = [
  (v51/*: any*/),
  (v52/*: any*/)
],
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPointStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v51/*: any*/),
    (v52/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementZoomLevelStyle",
      "kind": "LinkedField",
      "name": "zoomLevels",
      "plural": true,
      "selections": [
        (v53/*: any*/),
        (v54/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v55/*: any*/),
              "type": "MapElementPointStyle",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v55/*: any*/),
              "type": "MapElementCompoundFeatureStyle",
              "abstractKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v44/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "visualization",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v45/*: any*/)
              ],
              "type": "EventVisualization",
              "abstractKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/),
    (v56/*: any*/)
  ],
  "type": "PageSectionSidebarEventsList",
  "abstractKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayQuestionsLabel",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayParticipationData",
  "storageKey": null
},
v60 = [
  (v5/*: any*/),
  (v3/*: any*/)
],
v61 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "results",
  "plural": true,
  "selections": (v60/*: any*/),
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "participativeModuleIds",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipativeModule",
  "kind": "LinkedField",
  "name": "participativeModules",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v44/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v15/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Step",
      "kind": "LinkedField",
      "name": "currentStep",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "position",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDisplayAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDownAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsCountDisplayAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesUpCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesDownCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contributionsCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarResource",
  "kind": "LinkedField",
  "name": "resources",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v47/*: any*/),
    (v45/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endsAt",
      "storageKey": null
    },
    (v2/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventMode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "Sidebar",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSections",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v6/*: any*/),
      "concreteType": "PageSectionBaseConnection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageSectionBaseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v5/*: any*/),
                (v3/*: any*/),
                (v7/*: any*/),
                (v14/*: any*/),
                (v8/*: any*/),
                (v17/*: any*/),
                (v19/*: any*/),
                (v20/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v15/*: any*/),
                    (v21/*: any*/),
                    (v22/*: any*/),
                    (v18/*: any*/),
                    (v23/*: any*/),
                    (v24/*: any*/),
                    (v25/*: any*/),
                    (v27/*: any*/),
                    (v28/*: any*/),
                    (v36/*: any*/)
                  ],
                  "type": "PageSectionEmbed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v37/*: any*/),
                    (v38/*: any*/),
                    (v39/*: any*/),
                    (v16/*: any*/)
                  ],
                  "type": "PageSectionSidebarBanner",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v40/*: any*/),
                    (v16/*: any*/)
                  ],
                  "type": "PageSectionFilesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v41/*: any*/),
                    (v16/*: any*/)
                  ],
                  "type": "PageSectionPagesList",
                  "abstractKey": null
                },
                (v43/*: any*/),
                (v57/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v21/*: any*/),
                    (v15/*: any*/),
                    (v58/*: any*/),
                    (v59/*: any*/),
                    (v61/*: any*/),
                    (v62/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModuleResults",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v63/*: any*/),
                    (v16/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModulesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v21/*: any*/),
                    (v64/*: any*/)
                  ],
                  "type": "PageSectionCalendar",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v65/*: any*/)
          ],
          "storageKey": null
        },
        (v66/*: any*/)
      ],
      "storageKey": "sections(first:2147483647)"
    },
    {
      "alias": null,
      "args": (v6/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "Sidebar_sections",
      "kind": "LinkedHandle",
      "name": "sections"
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomDefault",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markersMaxClusterRadius",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tileLayerUrl",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mapDataAttribution",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterElementsOutOnInitialize",
  "storageKey": null
},
v73 = [
  (v3/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v75 = [
  (v47/*: any*/),
  (v48/*: any*/),
  (v74/*: any*/),
  (v29/*: any*/),
  (v46/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MapElementZoomLevelStyle",
    "kind": "LinkedField",
    "name": "zoomLevels",
    "plural": true,
    "selections": [
      (v53/*: any*/),
      (v54/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "style",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v47/*: any*/),
              (v48/*: any*/),
              (v74/*: any*/),
              (v29/*: any*/),
              (v46/*: any*/)
            ],
            "type": "MapElementPathStyle",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  (v3/*: any*/)
],
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPathStyle",
  "kind": "LinkedField",
  "name": "borderStyle",
  "plural": false,
  "selections": (v75/*: any*/),
  "storageKey": null
},
v77 = [
  (v2/*: any*/),
  (v15/*: any*/),
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PageRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Page_page"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ResourceTreeTaxonomy",
            "kind": "LinkedField",
            "name": "taxonomies",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Taxonomy",
                "kind": "LinkedField",
                "name": "taxonomy",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "titleImageUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowSendingNotificationOnContentUpdate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alreadySubscribed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subscribersCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resourcePath",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isResourceWithSubscription"
              }
            ],
            "type": "ResourceTreeLeaf",
            "abstractKey": "__isResourceTreeLeaf"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "PageSectionBaseConnection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageSectionBaseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v67/*: any*/)
                            ],
                            "type": "PageSectionText",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v67/*: any*/),
                              (v39/*: any*/)
                            ],
                            "type": "PageSectionBanner",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v21/*: any*/),
                              (v15/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v67/*: any*/),
                              (v63/*: any*/)
                            ],
                            "type": "PageSectionParticipativeModulesList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayMode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hideIfEmpty",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "events",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v44/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "visualization",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v45/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "placeName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "address",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "zip",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "city",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "EventVisualization",
                                        "abstractKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionEventsList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v67/*: any*/),
                              (v64/*: any*/)
                            ],
                            "type": "PageSectionCalendar",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actorsPerRow",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentAlignment",
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v67/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Actor",
                                "kind": "LinkedField",
                                "name": "actors",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ResponsiveImage",
                                    "kind": "LinkedField",
                                    "name": "logo",
                                    "plural": false,
                                    "selections": (v35/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionActorsList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              (v41/*: any*/)
                            ],
                            "type": "PageSectionPagesList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v67/*: any*/),
                              (v40/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isPageSectionWithHeadingData"
                              }
                            ],
                            "type": "PageSectionFilesList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "blocksDisplayMode",
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FeaturedContentBlock",
                                "kind": "LinkedField",
                                "name": "featuredContentBlocks",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v21/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "image",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v31/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ResponsiveImage",
                                    "kind": "LinkedField",
                                    "name": "originalImage",
                                    "plural": false,
                                    "selections": [
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "large",
                                        "plural": false,
                                        "selections": (v49/*: any*/),
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v67/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "blocksPerRow",
                                "storageKey": null
                              },
                              (v37/*: any*/),
                              (v38/*: any*/)
                            ],
                            "type": "PageSectionFeaturedContent",
                            "abstractKey": null
                          },
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              (v23/*: any*/),
                              (v22/*: any*/),
                              (v18/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isEmpty",
                                "storageKey": null
                              },
                              (v25/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v36/*: any*/)
                            ],
                            "type": "PageSectionEmbed",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              (v58/*: any*/),
                              (v59/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v67/*: any*/),
                              (v61/*: any*/),
                              (v62/*: any*/)
                            ],
                            "type": "PageSectionParticipativeModuleResults",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mapHeight",
                                "storageKey": null
                              },
                              (v68/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "map",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ParticipativeModule",
                                        "kind": "LinkedField",
                                        "name": "participativeModule",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ParticipativeModuleAuthorizations",
                                            "kind": "LinkedField",
                                            "name": "authorizations",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "contributionsDisplayAuthorized",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v44/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "visualization",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v69/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ParticipativeModule",
                                                    "kind": "LinkedField",
                                                    "name": "participativeModule",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Theme",
                                                        "kind": "LinkedField",
                                                        "name": "themes",
                                                        "plural": true,
                                                        "selections": [
                                                          (v3/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "MapElementThemeStyle",
                                                            "kind": "LinkedField",
                                                            "name": "style",
                                                            "plural": false,
                                                            "selections": (v50/*: any*/),
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v3/*: any*/),
                                                      (v44/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "contributionsZIndexOffset",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "ContributionsMap",
                                                "abstractKey": null
                                              },
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "VisualizationMap",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isMap"
                                  },
                                  (v44/*: any*/),
                                  (v3/*: any*/),
                                  (v68/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "zoomMin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "zoomMax",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileZoomDefault",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileZoomMin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileZoomMax",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "centerLatitude",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "centerLongitude",
                                    "storageKey": null
                                  },
                                  (v70/*: any*/),
                                  (v71/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapZoomLevelConfiguration",
                                    "kind": "LinkedField",
                                    "name": "zoomLevels",
                                    "plural": true,
                                    "selections": [
                                      (v53/*: any*/),
                                      (v54/*: any*/),
                                      (v70/*: any*/),
                                      (v71/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasElements",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "vectorTileUrl",
                                    "storageKey": null
                                  },
                                  (v69/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapElementPoint",
                                    "kind": "LinkedField",
                                    "name": "clusterizedPoints",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasInformationWindow",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "latitude",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "longitude",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mapElementGeometryId",
                                        "storageKey": null
                                      },
                                      (v56/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapElementTooltip",
                                        "kind": "LinkedField",
                                        "name": "tooltip",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapFilterList",
                                    "kind": "LinkedField",
                                    "name": "filterLists",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "filters",
                                        "plural": true,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v3/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v72/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MapTaxonomy",
                                                "kind": "LinkedField",
                                                "name": "mapTaxonomies",
                                                "plural": true,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "MapTaxonomy",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": true,
                                                    "selections": (v73/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "MapFilterTaxonomy",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v72/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "mapElements",
                                                "plural": true,
                                                "selections": (v60/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "MapFilterElement",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v6/*: any*/),
                                    "concreteType": "MapElementConnection",
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapElementEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v3/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MapTaxonomy",
                                                "kind": "LinkedField",
                                                "name": "mapTaxonomies",
                                                "plural": true,
                                                "selections": (v73/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isMapElement"
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "geometriesType",
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "MapElementCompoundFeatureStyle",
                                                    "kind": "LinkedField",
                                                    "name": "style",
                                                    "plural": false,
                                                    "selections": [
                                                      (v46/*: any*/),
                                                      (v51/*: any*/),
                                                      (v76/*: any*/),
                                                      (v52/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "MapElementShadowStyle",
                                                        "kind": "LinkedField",
                                                        "name": "shadowStyle",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "offsetX",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "offsetY",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "blur",
                                                            "storageKey": null
                                                          },
                                                          (v47/*: any*/),
                                                          (v48/*: any*/),
                                                          (v3/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "MapElementZoomLevelStyle",
                                                        "kind": "LinkedField",
                                                        "name": "zoomLevels",
                                                        "plural": true,
                                                        "selections": [
                                                          (v53/*: any*/),
                                                          (v54/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "style",
                                                            "plural": false,
                                                            "selections": [
                                                              (v5/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v51/*: any*/)
                                                                ],
                                                                "type": "MapElementCompoundFeatureStyle",
                                                                "abstractKey": null
                                                              },
                                                              (v3/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v3/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v3/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "MapElementCompoundFeature",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "MapElementPathStyle",
                                                    "kind": "LinkedField",
                                                    "name": "style",
                                                    "plural": false,
                                                    "selections": (v75/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "MapElementPath",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v56/*: any*/)
                                                ],
                                                "type": "MapElementPoint",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "MapElementShapeStyle",
                                                    "kind": "LinkedField",
                                                    "name": "style",
                                                    "plural": false,
                                                    "selections": [
                                                      (v46/*: any*/),
                                                      (v76/*: any*/),
                                                      (v52/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "MapElementZoomLevelStyle",
                                                        "kind": "LinkedField",
                                                        "name": "zoomLevels",
                                                        "plural": true,
                                                        "selections": [
                                                          (v53/*: any*/),
                                                          (v54/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "style",
                                                            "plural": false,
                                                            "selections": [
                                                              (v5/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v76/*: any*/),
                                                                  (v52/*: any*/)
                                                                ],
                                                                "type": "MapElementShapeStyle",
                                                                "abstractKey": null
                                                              },
                                                              (v3/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v3/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v3/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "MapElementShape",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v65/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": "elements(first:2147483647)"
                                  },
                                  {
                                    "alias": null,
                                    "args": (v6/*: any*/),
                                    "filters": null,
                                    "handle": "connection",
                                    "key": "MapElements_elements",
                                    "kind": "LinkedHandle",
                                    "name": "elements"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionMap",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SearchConfiguration",
                                "kind": "LinkedField",
                                "name": "searchConfiguration",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayOptionsByDefault",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionSearchBox",
                            "abstractKey": null
                          },
                          (v43/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v16/*: any*/)
                            ],
                            "type": "PageSectionSidebarBanner",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayLabel",
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "type": "PageSectionMapElementFeatureAttribute",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "defaultAcceptsCookiesValue",
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionCookiesConsentsConfiguration",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v77/*: any*/),
                            "type": "PageSectionSitemap",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v77/*: any*/),
                            "type": "PageSectionInformationSearch",
                            "abstractKey": null
                          },
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v65/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v66/*: any*/)
                ],
                "storageKey": "sections(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Page_sections",
                "kind": "LinkedHandle",
                "name": "sections"
              }
            ],
            "type": "ResourceWithSections",
            "abstractKey": "__isResourceWithSections"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1828bc9336e10793d8759e52b9523a8",
    "id": null,
    "metadata": {},
    "name": "PageRouteQuery",
    "operationKind": "query",
    "text": "query PageRouteQuery(\n  $id: ID!\n) {\n  page(id: $id) {\n    ...Page_page\n    id\n  }\n}\n\nfragment AnalyticsDatumCardRow_analyticsDatum on AnalyticsDatumInterface {\n  __isAnalyticsDatumInterface: __typename\n  label\n  count\n}\n\nfragment AudioPlayer_audio on Attachment {\n  url\n}\n\nfragment Breadcrumbs_page on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  title\n  ancestors {\n    __typename\n    id\n    title\n    resourcePath\n  }\n}\n\nfragment CalendarDayEventsPanel_events on CalendarResource {\n  id\n  ...CalendarResourceItem_event\n}\n\nfragment CalendarResourceItem_event on CalendarResource {\n  title\n  url\n  color\n  startsAt\n  endsAt\n  eventMode\n}\n\nfragment Calendar_section on PageSectionCalendar {\n  resources {\n    id\n    color\n    startsAt\n    endsAt\n    ...CalendarDayEventsPanel_events\n  }\n}\n\nfragment CardStep_step on Step {\n  name\n  startDate\n  endDate\n  isCurrent\n  position\n}\n\nfragment ContainerWithSidebar_sidebar on Sidebar {\n  hasSections\n  ...Sidebar_sidebar\n}\n\nfragment ContributionsMapContributionMarker_map on ContributionsMap {\n  contributionsZIndexOffset\n  participativeModule {\n    slug\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionsMarkersManager_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsMap {\n      ...ContributionsMapContributionsMarkers_map\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionsMarkers_map on ContributionsMap {\n  ...ContributionsMapThemeContributionsMarkers_map\n}\n\nfragment ContributionsMapThemeContributionsMarkers_map on ContributionsMap {\n  markersMaxClusterRadius\n  participativeModule {\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  ...ContributionsMapContributionMarker_map\n}\n\nfragment EventCard_participativeModule on Event {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n      placeName\n      address\n      zip\n      city\n    }\n    id\n  }\n}\n\nfragment FeaturedContentBlockImage_block on FeaturedContentBlock {\n  url\n  originalImage {\n    altText\n    large {\n      url\n    }\n    id\n  }\n}\n\nfragment FeaturedContentBlockText_block on FeaturedContentBlock {\n  title\n  description\n  url\n  image {\n    url\n    altText\n  }\n}\n\nfragment FeaturedContentBlock_block on FeaturedContentBlock {\n  title\n  ...FeaturedContentBlockText_block\n  ...FeaturedContentBlockImage_block\n}\n\nfragment FeaturedContentCarousel_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  autoplay\n  slidesInterval\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment FeaturedContentGrid_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment LibraryFile_file on LibraryFile {\n  name\n  url\n  size\n  fileExtension\n}\n\nfragment LinkSlide_slide on Slide {\n  url\n}\n\nfragment MapBase_map on Map {\n  __isMap: __typename\n  id\n  zoomDefault\n  zoomMin\n  zoomMax\n  mobileZoomDefault\n  mobileZoomMin\n  mobileZoomMax\n  centerLatitude\n  centerLongitude\n  tileLayerUrl\n  mapDataAttribution\n  zoomLevels {\n    zoomLevelMin\n    zoomLevelMax\n    tileLayerUrl\n    mapDataAttribution\n    id\n  }\n  ...MapElementsVectorGrid_map\n}\n\nfragment MapClusterizedPointMarker_point on MapElementPoint {\n  id\n  hasInformationWindow\n  latitude\n  longitude\n  mapElementGeometryId\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  tooltip {\n    ...MapElementTooltip_tooltip\n    id\n  }\n}\n\nfragment MapClusterizedPointMarkers_map on Map {\n  __isMap: __typename\n  markersMaxClusterRadius\n  clusterizedPoints {\n    id\n    ...MapClusterizedPointMarker_point\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapContextProvider_map on Map {\n  __isMap: __typename\n  __typename\n  slug\n}\n\nfragment MapElementTooltip_tooltip on MapElementTooltip {\n  content\n}\n\nfragment MapElementsVectorGridTileLayerStyles_map on Map {\n  __isMap: __typename\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        __isMapElement: __typename\n        id\n        geometriesType\n        ... on MapElementCompoundFeature {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            shadowStyle {\n              offsetX\n              offsetY\n              blur\n              color\n              opacity\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPath {\n          style {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPoint {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPointStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementShape {\n          style {\n            zIndexOffset\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementShapeStyle {\n                  borderStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                    zoomLevels {\n                      zoomLevelMin\n                      zoomLevelMax\n                      style {\n                        __typename\n                        ... on MapElementPathStyle {\n                          color\n                          opacity\n                          style\n                          width\n                          zIndexOffset\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapElementsVectorGrid_map on Map {\n  __isMap: __typename\n  id\n  hasElements\n  vectorTileUrl\n  ...MapClusterizedPointMarkers_map\n  ...MapElementsVectorGridTileLayerStyles_map\n}\n\nfragment MapSidebarEventsList_eventsList on PageSectionSidebarEventsList {\n  id\n  title\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n}\n\nfragment PageSectionActorsList_pageSection on PageSectionActorsList {\n  title\n  iconClass\n  description\n  actorsPerRow\n  contentAlignment\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  actors {\n    id\n    name\n    description\n    logo {\n      ...ResponsiveImage_image\n      id\n    }\n  }\n}\n\nfragment PageSectionAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionBanner_pageSection on PageSectionBanner {\n  autoplay\n  slidesInterval\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  slides {\n    id\n    ...Slide_slide\n  }\n}\n\nfragment PageSectionCalendar_pageSection on PageSectionCalendar {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...Calendar_section\n}\n\nfragment PageSectionCookiesConsentsConfiguration_pageSection on PageSectionCookiesConsentsConfiguration {\n  title\n  iconClass\n  description\n  defaultAcceptsCookiesValue\n}\n\nfragment PageSectionEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  hlsUrl\n  code\n  url\n  format\n  isEmpty\n  mediaTitle\n  collapsible\n  collapsedHeight\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionEventsList_pageSection on PageSectionEventsList {\n  title\n  description\n  displayMode\n  hideIfEmpty\n  events {\n    id\n    ...EventCard_participativeModule\n  }\n}\n\nfragment PageSectionFeaturedContent_pageSection on PageSectionFeaturedContent {\n  title\n  iconClass\n  description\n  blocksDisplayMode\n  columnsRatio\n  columnsOrder\n  collapsible\n  collapsedHeight\n  featuredContentBlocks {\n    __typename\n    id\n  }\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...FeaturedContentGrid_featuredContent\n  ...FeaturedContentCarousel_featuredContent\n}\n\nfragment PageSectionFilesList_pageSection on PageSectionFilesList {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    hasSections\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  files {\n    id\n    ...LibraryFile_file\n  }\n}\n\nfragment PageSectionInformationSearch_pageSection on PageSectionInformationSearch {\n  id\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionMapElementFeatureAttribute_pageSection on PageSectionMapElementFeatureAttribute {\n  label\n  displayLabel\n  content\n}\n\nfragment PageSectionMap_pageSection on PageSectionMap {\n  title\n  description\n  mapHeight\n  zoomDefault\n  map {\n    __typename\n    ... on VisualizationMap {\n      participativeModule {\n        authorizations {\n          contributionsDisplayAuthorized\n        }\n        ...ContributionsMapContributionsMarkersManager_participativeModule\n        id\n      }\n    }\n    ...MapContextProvider_map\n    ...MapBase_map\n    id\n  }\n}\n\nfragment PageSectionPagesList_pageSection on PageSectionPagesList {\n  title\n  iconClass\n  description\n  resourceTargets {\n    id\n    name\n    url\n  }\n}\n\nfragment PageSectionParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  iconClass\n  description\n  displayQuestionsLabel\n  displayParticipationData\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  title\n  description\n  iconClass\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n}\n\nfragment PageSectionSearchBox_pageSection on PageSectionSearchBox {\n  title\n  iconClass\n  description\n  searchConfiguration {\n    id\n    displayOptionsByDefault\n  }\n}\n\nfragment PageSectionSidebarAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionSidebarBanner_pageSection on PageSectionSidebarBanner {\n  fullHeight\n  autoplay\n  slidesInterval\n  slides {\n    id\n    ...Slide_slide\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarCalendar_pageSection on PageSectionCalendar {\n  title\n  description\n  ...Calendar_section\n}\n\nfragment PageSectionSidebarEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  code\n  url\n  hlsUrl\n  format\n  mediaTitle\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionSidebarEventsList_pageSection on PageSectionSidebarEventsList {\n  id\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n  ...MapSidebarEventsList_eventsList\n}\n\nfragment PageSectionSidebarFilesList_pageSection on PageSectionFilesList {\n  files {\n    id\n    ...LibraryFile_file\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarLinkBlock_pageSection on PageSectionSidebarLinkBlock {\n  title\n  subtitle\n  iconClass\n  url\n}\n\nfragment PageSectionSidebarPagesList_pageSection on PageSectionPagesList {\n  resourceTargets {\n    id\n    name\n    url\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  description\n  iconClass\n  displayQuestionsLabel\n  displayParticipationData\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarText_pageSection on PageSectionSidebarText {\n  content\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarUsersGroupRequestLinkBlock_pageSection on PageSectionSidebarUsersGroupRequestLinkBlock {\n  iconClass\n  addRequestTitle\n  removeRequestTitle\n  usersGroup {\n    id\n    name\n    alreadyGroupMember\n    alreadyRequested\n    authorizations {\n      sendJoinGroupRequest\n    }\n  }\n}\n\nfragment PageSectionSidebar_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionSidebarEmbed_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarPagesList_pageSection\n  ...PageSectionSidebarAnalyticsDataList_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n  ...PageSectionSidebarParticipativeModuleResults_pageSection\n  ...PageSectionSidebarParticipativeModulesList_pageSection\n  ...PageSectionSidebarCalendar_pageSection\n}\n\nfragment PageSectionSitemap_pageSection on PageSectionSitemap {\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionText_pageSection on PageSectionText {\n  content\n  collapsible\n  collapsedHeight\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n}\n\nfragment PageSection_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionText_pageSection\n  ...PageSectionBanner_pageSection\n  ...PageSectionParticipativeModulesList_pageSection\n  ...PageSectionEventsList_pageSection\n  ...PageSectionCalendar_pageSection\n  ...PageSectionActorsList_pageSection\n  ...PageSectionPagesList_pageSection\n  ...PageSectionFilesList_pageSection\n  ...PageSectionFeaturedContent_pageSection\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionEmbed_pageSection\n  ...PageSectionParticipativeModuleResults_pageSection\n  ...PageSectionMap_pageSection\n  ...PageSectionSearchBox_pageSection\n  ...PageSectionAnalyticsDataList_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionMapElementFeatureAttribute_pageSection\n  ...PageSectionCookiesConsentsConfiguration_pageSection\n  ...PageSectionSitemap_pageSection\n  ...PageSectionInformationSearch_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n}\n\nfragment PageSections_page on ResourceWithSections {\n  __isResourceWithSections: __typename\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        ...PageSection_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Page_page on Page {\n  title\n  publishedAt\n  ...Subscription_subscribable\n  ...PageSections_page\n  ...Breadcrumbs_page\n  taxonomies {\n    ...TaxonomyIcons_taxonomies\n    id\n  }\n}\n\nfragment ParticipativeModuleCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  thumbUrl\n  visualization {\n    __typename\n    iconClass\n    id\n  }\n  currentStep {\n    ...CardStep_step\n    id\n  }\n  ...ParticipativeModuleMeasures_participativeModule\n}\n\nfragment ParticipativeModuleMeasures_participativeModule on ParticipativeModule {\n  authorizations {\n    votesDisplayAuthorized\n    votesDownAuthorized\n    contributionsCountDisplayAuthorized\n  }\n  votesUpCount\n  votesDownCount\n  contributionsCount\n}\n\nfragment ParticipativeModuleResultsFormFields_pageSection on PageSectionParticipativeModuleResults {\n  id\n  participativeModuleIds\n}\n\nfragment ResponsiveImage_image on ResponsiveImage {\n  altText\n  large {\n    ratio\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  medium {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  small {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n}\n\nfragment SidebarEventCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n    }\n    id\n  }\n}\n\nfragment Sidebar_sidebar on Sidebar {\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        fullHeight\n        ...PageSectionSidebar_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SlideCaption_slide on Slide {\n  caption\n}\n\nfragment SlideContainer_slide on Slide {\n  url\n  enableOverlay\n  ...LinkSlide_slide\n}\n\nfragment SlideOverlay_slide on Slide {\n  url\n  enableOverlay\n  overlayContent\n  overlayButtonText\n  overlayContentPosition\n  overlayContentTextColor\n  overlayButtonBackgroundColor\n  overlayButtonTextColor\n  overlayBackgroundColor\n  overlayOpacity\n}\n\nfragment Slide_slide on Slide {\n  ...SlideContainer_slide\n  ...SlideCaption_slide\n  ...SlideOverlay_slide\n  image {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment SubscriptionModal_subscribable on ResourceWithSubscription {\n  __isResourceWithSubscription: __typename\n  id\n}\n\nfragment Subscription_subscribable on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  id\n  allowSendingNotificationOnContentUpdate\n  alreadySubscribed\n  subscribersCount\n  ...SubscriptionModal_subscribable\n}\n\nfragment TaxonomyIcons_taxonomies on ResourceTreeTaxonomy {\n  taxonomy {\n    id\n    name\n    titleImageUrl\n  }\n}\n\nfragment VideoPlayer_withVideoStream on WithBunnyStreamVideo {\n  __isWithBunnyStreamVideo: __typename\n  hlsUrl\n  hlsLibUrl\n  width\n  height\n  cover {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment useMapElementsFilteredIn_map on Map {\n  __isMap: __typename\n  id\n  filterLists {\n    filters {\n      __typename\n      id\n      ... on MapFilterTaxonomy {\n        filterElementsOutOnInitialize\n        mapTaxonomies {\n          id\n          children {\n            id\n          }\n        }\n      }\n      ... on MapFilterElement {\n        filterElementsOutOnInitialize\n        mapElements {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        mapTaxonomies {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useSidebarSectionTitle_pageSection on PageSectionWithHeadingData {\n  __isPageSectionWithHeadingData: __typename\n  title\n  iconClass\n}\n"
  }
};
})();

node.hash = "d0f37e8338afc6aea2831c18a4591663";

module.exports = node;
